import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Button,
  Fab
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { IconButton, Typography} from '@material-ui/core';
import Dialog from '../Dialog';
import DocumentList from '../DocumenList';
import FancyDropDown from '../FancyDropDown';
import { useParams } from 'react-router-dom';

import DocumentSearchDialog from '../DocumentSearchDialog';
import SearchIcon from '@material-ui/icons/Search';
//import ToggleButton from '@material-ui/cor';
//import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';



const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  simpleLabel: {
    display: 'inline-block',
    marginTop: 2
  },
  editHazardFieldsContainer: {
    padding: theme.spacing(2)
  },
  backArrow: {
    marginLeft: -16
  },
  courseName: {
    fontWeight: 600
  },
  addControlButton: {
    marginTop: 8
  },
  dropDown: {
    width: 200,
  }
}));

const DocumentListDialog = (props) => {
  const classes = useStyles();
  const {
    open,
    documents,
    allDocumentsForLibrary,
    course,
    onOpenDocumentListDialog,
    currentDirectory,
    defaultDirectory,
    onShowFolderItems,
    onBackClicked,
    onReset,
    handleDocumentSelected,
    isLoading,
    fetchAllDocuments,
    fetchAllDocumentsForLibrary,
    onFullReset,
    showDropdown,
    branchId

  } = props;


  const items = [{id:1, value: "Global Documents Library", name: "Documents"}, {id:2, value:"Client Document Library", name:"Branch Documents"}]

  const [alignment, setAlignment] = React.useState(1);

  const [openSearch, setOpenSearch] = React.useState(false);

  //let { branchId } = useParams();

    React.useEffect(
    () => {

      if(open === true && alignment === 1){
        fetchAllDocuments(branchId);
      }
      else if(open === true && alignment === 2){
        fetchAllDocumentsForLibrary(branchId);
      }

      return () => {
        setAlignment(1);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  );   

  const handleSearchClosed = () => {
    debugger;
    setOpenSearch(false);
  };


  const onDialogClose = () => {
    onOpenDocumentListDialog(false);
    onFullReset();
  };

  const handleFolderClick = (folder) => {
    onShowFolderItems(folder.documentName);
  };

  const handleDocumentClick = (document) => {

    const documentLink =
       document.blobName;
    handleDocumentSelected(documentLink);

    onDialogClose();
  };




  const handleDocumentClickFromSearch = (document) => {
   // window.open(document.blobFullUrl, '_blank', 'noopener,noreferrer');
    // handleDocumentSelected(documentLink);
    setOpenSearch(false);
    const documentLink =
    document.blobName;
 handleDocumentSelected(documentLink);
 onDialogClose();
  };

  const handleBackButtonClicked = () => {
    onBackClicked();
  };

  const handleRemoveButtonClicked = () => {
    handleDocumentSelected(null);
    onDialogClose();
  };

  const handleDropdownChange = (e) => {
  
    setAlignment(e.target.value);

     if(e.target.value === 1){
      fetchAllDocuments(branchId);
    }
    else if (e.target.value === 2){
     fetchAllDocumentsForLibrary(branchId);
    } 
  }

  const showBackBtn = currentDirectory === defaultDirectory ? false : true;

  return (
    <React.Fragment>

{openSearch && (
        <DocumentSearchDialog
          open={openSearch}
          documents={allDocumentsForLibrary}
          handleSearchClosed={handleSearchClosed}
          handleDocumentClick={handleDocumentClickFromSearch}
        />
      )}

      <Dialog
        children
        open={open}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialogChild}
      >
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          Documents
        </DialogTitle>
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          
          {showDropdown &&  <FancyDropDown
                htmlId="documentDropdown"
                label="Document library"
                margin="normal"
                
                handleChange={handleDropdownChange
                }
                items={items}
                value={alignment}
                dropDownWidth="100%"
                className={"dropDown"}
                valueField="id"
                displayField="value"
                required={true}
              />
          }
        
        </DialogTitle>

        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
        {showDropdown && documents && documents.length > 0 && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpenSearch(true)}
              >
                Search Documents
              </Button>
            )}
             </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {isLoading ? <LinearProgress /> : ''}

          {showBackBtn ? (
            <div className={classes.backArrowContainer}>
              <IconButton
                color="inherit"
                onClick={handleBackButtonClicked}
                id="settings-button"
                className={classes.backArrow}
              >
                <ArrowBackIcon color="primary" />
              </IconButton>
              <Typography className={classes.simpleLabel}>
                {' '}
                {currentDirectory}
              </Typography>
            </div>
          ) : (
            <div className={classes.backArrowContainer}>
              <Typography className={classes.simpleLabel}>
                {' '}
                {currentDirectory}
              </Typography>
            </div>
          )}
          {documents && (
            <DocumentList
              documents={documents}
              handleFolderClick={handleFolderClick}
              handleDocumentClick={handleDocumentClick}
            />
          )}
        </DialogContent>
        <DialogActions className={classes.footer}>
          {course.document != null && (
            <Button
              className={classes.actionButton}
              color="primary"
              variant="outlined"
              onClick={handleRemoveButtonClicked}
            >
              Remove
            </Button>
          )}
          <Button
            className={classes.actionButton}
            color="primary"
            variant="outlined"
            onClick={onDialogClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DocumentListDialog;
